import React from 'react'
// import { Link } from 'react-router-dom';
import { Helmet } from "react-helmet-async";
import ContactForm from '../Components/ContactForm'
import { Container} from 'react-bootstrap'
import aboutBannerImg from '../assets/home/About banner1.png';
import "./Contact.css"

const Contact = () => {
  return (
    <> 
    <Helmet>
  <title>Contact 21 Maneuvers | Best Digital Marketing Agency in Bareilly</title>

  <meta 
    name="description" 
    content="Contact 21 Maneuvers - the best digital marketing agency in Bareilly, Uttar Pradesh. Get in touch for SEO, website development, branding & social media marketing services."
  />

  <meta 
    name="keywords" 
    content="digital marketing agency in Bareilly, SEO company Bareilly, website development Bareilly, social media marketing Bareilly, branding agency Bareilly Uttar Pradesh"
  />

  <link rel="canonical" href="https://21maneuvers.in/contact" />

  {/* Open Graph */}
  <meta property="og:title" content="Contact Best Digital Marketing Agency in Bareilly | 21 Maneuvers" />
  <meta property="og:description" content="Get in touch with Bareilly’s leading digital marketing agency for SEO, branding & website services." />
  <meta property="og:url" content="https://21maneuvers.in/contact" />
  <meta property="og:type" content="website" />
</Helmet>
  
    <Container fluid className='g-0' >
       <section className="aboutbanner">
      <img
        src={aboutBannerImg}
        alt="About Banner"
        className="aboutbanner-image"
      />
    </section>


      <Container className='contactUs-content-container'>
        <h1 style={{
  position: "absolute",
  left: "-9999px",
  height: "1px",
  overflow: "hidden"
}}>
  Contact Digital Marketing Agency in Bareilly - 21 Maneuvers
</h1>
        <p>
          Home <span className="">{'>'}</span> Contact Us
        </p>
          <h3 className='page_heading'>Get in touch</h3>
        <div className='contactUs-row'>
          <div  className='left-col'>
            <div className='left-col-content'>
              <div className='heading-text-div'>
                <p className='service-points' >Work Inquiries</p>
                <p className='fw-bold service-points'>+91 9311849502</p>
                <p className='service-points' >Assistance hours:<br /> Monday – Saturday <br />11 am to 7 pm EST</p>
              </div>

              <div className='heading-text-div'>
                <p className='service-points'>Careers</p>
                <p className='fw-bold service-points'>Twentyone@21maneuvers.in</p>
                <p className='service-points' >Assistance hours:<br />Tuesday – Saturday <br/>12 am to 5 pm EST</p>
              </div>
            </div>
          </div>

          <div  className='right-col'>
            <div className='right-col-content'>
              <div >
                <p className='fw-bold service-points '>Post address</p>
              <span className='service-points'>
                <p className='fw-bold'>Assettlor Interactive Studios.</p>
                <p>K.B. Marketing OPC Pvt. Ltd, C-12-35 Rampur Bagh,</p>
                <p>Bareilly,</p>
                <p>India </p>
                </span>
              </div>
              <div>
                <p className='fw-bold service-points'>Social media</p>
                 <a style={{ textDecoration:"none"}} href="https://www.facebook.com/21Maneuvers" target="_blank" rel="noopener noreferrer" > <p className='fw-bold link-text' >Facebook</p></a>
                        <a style={{ textDecoration:"none"}} href="https://www.instagram.com/21.maneuvers/" target="_blank" rel="noopener noreferrer" >  <p className='fw-bold link-text' style={{ marginTop: "-8px" }}>Instagram</p></a>
                        <a style={{ textDecoration:"none"}} href="https://wa.me/919927600436" target="_blank" rel="noopener noreferrer" >     <p className='fw-bold link-text' style={{ marginTop: "-8px" }}>Whatsapp</p></a>
                        <a  style={{ textDecoration:"none"}} href="https://www.linkedin.com/company/21-maneuvers/" target="_blank" rel="noopener noreferrer" > <p className='fw-bold link-text' style={{ marginTop: "-8px" }}>Linkedin</p></a>
               
              </div>
            </div>
          </div>
        </div>
      </Container>

      <Container className='contactUs-underline mt-5'></Container>

      <div style={{ width: "100%", marginTop: "5%", marginBottom: "5%" }}>
        <ContactForm />
      </div>

      <Container>
        <div style={{ width: '100%', height: '400px' }}>
    
          <iframe
            title="Google Map"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d7022.603673758518!2d79.42553909173127!3d28.34972279373881!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39a000d5f4d03455%3A0x61c318777d4f744d!2sC-12%2C%20Rampur%20Garden%2C%20Bareilly%2C%20Uttar%20Pradesh%20243001!5e0!3m2!1sen!2sin!4v1776940834631!5m2!1sen!2sin" width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"
            width="100%"
            height="100%"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>
      </Container>

    </Container>
    </>
  )
}

export default Contact